import { render } from "./WarningModal.vue?vue&type=template&id=63e5a814"
import script from "./WarningModal.vue?vue&type=script&lang=js"
export * from "./WarningModal.vue?vue&type=script&lang=js"

import "./WarningModal.vue?vue&type=style&index=0&id=63e5a814&lang=scss"

import exportComponent from "C:\\Projects\\Vind\\Vind\\VindFront\\VindFrontVueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__